<template>
  <div class="new-customer-screen">
    <v-form ref="customerForm" lazy-validation>
      <div class="entity-panel">
        <div class="segment-title">Tipo de cliente</div>
        <div class="entity-options">
          <label class="entity-option">
            <input
              type="checkbox"
              :checked="entitySelection.isBusiness"
              @change="toggleEntity('isBusiness')"
            />
            <span>Es tributario/negocio</span>
          </label>

          <label class="entity-option">
            <input
              type="checkbox"
              :checked="entitySelection.isOng"
              @change="toggleEntity('isOng')"
            />
            <span>ONG</span>
          </label>

          <label class="entity-option">
            <input
              type="checkbox"
              :checked="entitySelection.isPublicEntity"
              @change="toggleEntity('isPublicEntity')"
            />
            <span>Institución pública</span>
          </label>
        </div>
      </div>

      <template v-if="!modeEnterprise">
        <div class="section-block">
        <div class="segment-title">Datos básicos</div>
        <v-row class="field-row">
          <v-col cols="12" class="mb-4" md="4" lg="3">
            <v-text-field
              v-model="personForm.firstname"
              outlined
              dense
              hide-details="auto"
              label="Nombre: *"
              :rules="required"
              @input="syncPersonLegalName"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="4" lg="3">
            <v-text-field
              v-model="personForm.lastname"
              outlined
              dense
              hide-details="auto"
              label="Apellido: *"
              :rules="required"
              @input="syncPersonLegalName"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="4" lg="4">
            <v-text-field
              v-model="personForm.legalname"
              outlined
              dense
              hide-details="auto"
              label="Nombre en factura: *"
              :rules="required"
              @input="markPersonLegalNameAsManual"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="4" lg="2">
            <v-select
              v-model="personForm.gender"
              outlined
              dense
              hide-details="auto"
              :items="genderOptions"
              label="Sexo"
            />
          </v-col>
        </v-row>
        </div>

        <div class="section-block">
        <div class="segment-title">Contactos</div>
        <v-row class="field-row">
          <v-col cols="12" class="mb-4" md="4" lg="3">
            <date-picker
              label="Fecha de nacimiento"
              v-model="dateOfBirth"
              @update="calculateAgeWithDOB"
            ></date-picker>
          </v-col>
          <v-col cols="12" class="mb-4" md="2" lg="1">
            <v-text-field
              v-model="personForm.age"
              outlined
              dense
              hide-details="auto"
              label="Edad"
              type="number"
              @input="calculateDOBwithAge"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="3" lg="2">
            <v-select
              v-model="commonForm.prefijo"
              outlined
              dense
              hide-details="auto"
              :items="prefixOptions"
              item-text="ParameterValue"
              item-value="ParameterValue"
              label="Prefijo"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="4" lg="3">
            <v-text-field
              v-model="personForm.phonenumber"
              outlined
              dense
              hide-details="auto"
              label="Número de teléfono"
              @input="maskNumbers"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="4" lg="3">
            <v-text-field
              v-model="personForm.mobilenumber"
              outlined
              dense
              hide-details="auto"
              label="Celular: *"
              :rules="required"
              @input="maskNumbers"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="4">
            <v-text-field
              v-model="personForm.email"
              outlined
              dense
              hide-details="auto"
              label="Correo electrónico: *"
              :rules="emailRules"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="8">
            <v-text-field
              v-model="personForm.address"
              outlined
              dense
              hide-details="auto"
              label="Dirección: *"
              :rules="required"
              @input="handleAddressInput(personForm, 'address')"
            />
          </v-col>
        </v-row>
        </div>

        <div class="section-block">
        <div class="segment-title">Ubicación</div>
        <v-row class="field-row">
          <v-col cols="12" class="mb-4" md="4">
            <v-autocomplete
              v-model="commonForm.country"
              outlined
              dense
              hide-details="auto"
              :items="countryList"
              item-text="name"
              item-value="name"
              label="País *"
              :rules="required"
              @change="handleCountryChange"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="4">
            <v-autocomplete
              v-if="isElSalvador"
              v-model="commonForm.department"
              outlined
              dense
              hide-details="auto"
              :items="departments"
              item-text="Valores"
              item-value="Codigo"
              label="Estado/Departamento *"
              :rules="required"
            />
            <v-autocomplete
              v-else
              v-model="commonForm.department"
              outlined
              dense
              hide-details="auto"
              :items="stateList"
              item-text="name"
              label="Estado/Departamento *"
              :rules="required"
              @change="getCities"
            >
              <template v-slot:no-data>
                <div class="px-4">{{ noDataLabelStates }}</div>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" class="mb-4" md="4">
            <v-autocomplete
              v-if="isElSalvador"
              v-model="commonForm.municipality"
              outlined
              dense
              hide-details="auto"
              :items="municipalities"
              item-text="Valores"
              item-value="Codigo"
              label="Ciudad *"
              :rules="required"
              :readonly="!commonForm.department"
            />
            <v-autocomplete
              v-else-if="cityList.length > 0 || noDataLabelCities === 'Cargando...'"
              v-model="commonForm.municipality"
              outlined
              dense
              hide-details="auto"
              :items="cityList"
              item-text="name"
              label="Ciudad *"
              :rules="required"
              :readonly="!commonForm.department"
            >
              <template v-slot:no-data>
                <div class="px-4">{{ noDataLabelCities }}</div>
              </template>
            </v-autocomplete>
            <v-text-field
              v-else
              v-model="commonForm.municipality"
              outlined
              dense
              hide-details="auto"
              label="Ciudad *"
              :rules="required"
            />
          </v-col>
        </v-row>
        </div>

        <div class="section-block">
        <div class="segment-title">Identificación</div>
        <v-row class="field-row">
          <v-col cols="12" class="mb-4" md="4">
            <v-autocomplete
              v-model="personForm.documenttype"
              outlined
              dense
              hide-details="auto"
              :items="documentTypes"
              item-text="DocumentType"
              item-value="ID_DocumentType"
              label="Tipo de documento"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="4">
            <v-text-field
              v-model="personDocumentValue"
              outlined
              dense
              hide-details="auto"
              :label="personDocumentLabel"
              @input="maskDocumentValue('person')"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="4">
            <v-text-field
              v-model="personForm.oldid"
              outlined
              dense
              hide-details="auto"
              label="Código alterno"
            />
          </v-col>
        </v-row>
        </div>
      </template>

      <template v-else>
        <div class="section-block">
        <div class="segment-title">Datos básicos del negocio</div>
        <v-row class="field-row">
          <v-col cols="12" class="mb-4" md="6">
            <v-text-field
              v-model="businessForm.businessname"
              outlined
              dense
              hide-details="auto"
              label="Nombre del negocio: *"
              :rules="required"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="6">
            <v-text-field
              v-model="businessForm.businessemail"
              outlined
              dense
              hide-details="auto"
              label="Correo del negocio: *"
              :rules="emailRules"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="2">
            <v-text-field
              v-model="businessForm.businessphone"
              outlined
              dense
              hide-details="auto"
              label="Teléfono del negocio"
              @input="maskNumbers"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="2">
            <v-text-field
              v-model="businessForm.businessmobile"
              outlined
              dense
              hide-details="auto"
              label="Celular del negocio: *"
              :rules="required"
              @input="maskNumbers"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="8">
            <v-text-field
              v-model="businessForm.legaladdress"
              outlined
              dense
              hide-details="auto"
              label="Dirección legal: *"
              :rules="required"
            />
          </v-col>
        </v-row>
        </div>

        <div class="section-block">
        <div class="segment-title">Ubicación</div>
        <v-row class="field-row">
          <v-col cols="12" class="mb-4" md="4">
            <v-autocomplete
              v-model="commonForm.country"
              outlined
              dense
              hide-details="auto"
              :items="countryList"
              item-text="name"
              item-value="name"
              label="País *"
              :rules="required"
              @change="handleCountryChange"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="4">
            <v-autocomplete
              v-if="isElSalvador"
              v-model="commonForm.department"
              outlined
              dense
              hide-details="auto"
              :items="departments"
              item-text="Valores"
              item-value="Codigo"
              label="Estado/Departamento *"
              :rules="required"
            />
            <v-autocomplete
              v-else
              v-model="commonForm.department"
              outlined
              dense
              hide-details="auto"
              :items="stateList"
              item-text="name"
              label="Estado/Departamento *"
              :rules="required"
              @change="getCities"
            >
              <template v-slot:no-data>
                <div class="px-4">{{ noDataLabelStates }}</div>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" class="mb-4" md="4">
            <v-autocomplete
              v-if="isElSalvador"
              v-model="commonForm.municipality"
              outlined
              dense
              hide-details="auto"
              :items="municipalities"
              item-text="Valores"
              item-value="Codigo"
              label="Ciudad *"
              :rules="required"
              :readonly="!commonForm.department"
            />
            <v-autocomplete
              v-else-if="cityList.length > 0 || noDataLabelCities === 'Cargando...'"
              v-model="commonForm.municipality"
              outlined
              dense
              hide-details="auto"
              :items="cityList"
              item-text="name"
              label="Ciudad *"
              :rules="required"
              :readonly="!commonForm.department"
            >
              <template v-slot:no-data>
                <div class="px-4">{{ noDataLabelCities }}</div>
              </template>
            </v-autocomplete>
            <v-text-field
              v-else
              v-model="commonForm.municipality"
              outlined
              dense
              hide-details="auto"
              label="Ciudad *"
              :rules="required"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="4">
            <v-text-field
              v-model="businessForm.oldid"
              outlined
              dense
              hide-details="auto"
              label="Código alterno"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="4">
            <v-autocomplete
              v-model="commonForm.businesssector"
              outlined
              dense
              hide-details="auto"
              :items="tipoIngresoOptions"
              item-text="Valores"
              item-value="Codigo"
              label="Tipo de ingreso: *"
              :rules="required"
            />
          </v-col>
        </v-row>
        </div>

        <div class="section-block">
        <div class="segment-title">Contacto principal</div>
        <v-row class="field-row">
          <v-col cols="12" class="mb-4" md="4" lg="2">
            <v-select
              v-model="commonForm.prefijo"
              outlined
              dense
              hide-details="auto"
              :items="prefixOptions"
              item-text="ParameterValue"
              item-value="ParameterValue"
              label="Prefijo"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="4" lg="5">
            <v-text-field
              v-model="businessForm.businesscontactname"
              outlined
              dense
              hide-details="auto"
              label="Nombre del contacto: *"
              :rules="required"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="4" lg="5">
            <v-text-field
              v-model="businessForm.businesscontactemail"
              outlined
              dense
              hide-details="auto"
              label="Correo electrónico del contacto: *"
              :rules="emailRules"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="3">
            <v-text-field
              v-model="businessForm.businesscontactphone"
              outlined
              dense
              hide-details="auto"
              label="Teléfono del contacto: *"
              :rules="required"
              @input="maskNumbers"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="3">
            <v-text-field
              v-model="businessForm.businesscontactmobile"
              outlined
              dense
              hide-details="auto"
              label="Celular del contacto: *"
              :rules="required"
              @input="maskNumbers"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="3">
            <v-autocomplete
              v-model="businessForm.documenttype"
              outlined
              dense
              hide-details="auto"
              :items="documentTypes"
              item-text="DocumentType"
              item-value="ID_DocumentType"
              label="Tipo de documento"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="3">
            <v-text-field
              v-model="businessContactDocumentValue"
              outlined
              dense
              hide-details="auto"
              :label="businessContactDocumentLabel"
              @input="maskDocumentValue('business')"
            />
          </v-col>
        </v-row>
        </div>

        <div class="section-block">
        <div class="segment-title">Información tributaria</div>
        <v-row class="field-row">
          <v-col cols="12" class="mb-4" md="6">
            <v-text-field
              v-model="businessForm.legalname"
              outlined
              dense
              hide-details="auto"
              label="Nombre legal: *"
              :rules="required"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="3" v-if="isElSalvador">
            <v-text-field
              v-model="businessForm.legalnrc"
              outlined
              dense
              hide-details="auto"
              :label="entitySelection.isBusiness ? 'NRC legal: *' : 'NRC legal'"
              :rules="entitySelection.isBusiness && isElSalvador ? required : []"
              @input="maskNrc"
            />
          </v-col>
          <v-col cols="12" class="mb-4" :md="isElSalvador ? 3 : 6">
            <v-text-field
              v-model="businessForm.legalnit"
              outlined
              dense
              hide-details="auto"
              :label="entitySelection.isBusiness && isElSalvador ? 'Número de NIT: *' : 'Número de NIT'"
              :rules="entitySelection.isBusiness && isElSalvador ? required : []"
              @keyup="maskNit"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="6">
            <v-autocomplete
              v-if="isElSalvador"
              v-model="commonForm.codactividad"
              outlined
              dense
              hide-details="auto"
              :items="activities"
              item-text="Valores"
              item-value="Codigo"
              label="Actividad económica: *"
              :rules="required"
              @change="changeActivity"
            />
            <v-text-field
              v-else
              v-model="businessForm.typedDescActividad"
              outlined
              dense
              hide-details="auto"
              label="Actividad económica: *"
              :rules="required"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="3">
            <v-autocomplete
              v-model="businessForm.legalentity"
              outlined
              dense
              hide-details="auto"
              :items="businessEntityOptions"
              label="Entidad legal: *"
              :rules="required"
            />
          </v-col>
          <v-col cols="12" class="mb-4" md="3" v-if="isElSalvador">
            <v-select
              v-model="businessForm.legaltaxpayersize"
              outlined
              dense
              hide-details="auto"
              :items="taxpayerSizeOptions"
              item-text="value"
              item-value="key"
              label="Tamaño legal: *"
              :rules="required"
            />
          </v-col>
          <v-col cols="12" md="6" class="d-flex align-center">
            <v-checkbox
              v-model="businessForm.legalagentretain"
              hide-details
              label="Es agente de retención 1%"
            />
          </v-col>
          <v-col cols="12" md="6" class="d-flex align-center" v-if="entitySelection.isPublicEntity">
            <v-checkbox
              v-model="businessForm.removerestrictionpublicentity"
              hide-details
              label="Es exento"
            />
          </v-col>
        </v-row>
        </div>
      </template>

      <v-card flat class="mt-4">
        <v-card-actions class="px-0">
          <v-btn text color="primary" @click="$emit('cancel')">Volver</v-btn>
          <v-spacer />
          <v-btn color="comment" dark @click="submit">Guardar cliente</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { numberSV, dui as duiMask, nrc as nrcMask, nitMaskHandlingHomologation } from "@/helpers/masks"
import { validateNITHomologation } from "@/helpers/object"
import DatePicker from "@/components/DatePicker2.vue"

const EL_SALVADOR = "El Salvador"

function normalizeEntityLabel(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase()
}

function filterEntityOptionsByCountry(options, country) {
  if (country !== EL_SALVADOR) return options

  return options.filter((option) => {
    const normalized = normalizeEntityLabel(option)
    return normalized === "PERSONA NATURAL" || normalized === "PERSONA JURIDICA"
  })
}

export default {
  name: "NewCustomerScreen",
  components: {
    DatePicker,
  },
  props: {
    initialInvoiceType: {
      type: String,
      default: "FCF",
    },
  },
  data() {
    return {
      required: [(v) => !!v || "Este campo es obligatorio"],
      emailRules: [
        (v) => !!v || "Este campo es obligatorio",
        (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v || "") || "Correo inválido",
      ],
      genderOptions: ["Masculino", "Femenino"],
      prefixOptions: [],
      documentTypes: [],
      stateList: [],
      cityList: [],
      noDataLabelStates: "Seleccione un país",
      noDataLabelCities: "Seleccione un estado",
      taxpayerSizeOptions: [
        { key: "MEDIANO", value: "MEDIANO" },
        { key: "PEQUEÑO", value: "PEQUEÑO" },
        { key: "GRANDE", value: "GRANDE" },
      ],
      businessEntity: [
        "PERSONA NATURAL",
        "PERSONA JURÍDICA",
        "SOCIEDAD ANÓNIMA",
        "CORPORACIÓN",
      ],
      entitySelection: {
        isBusiness: false,
        isOng: false,
        isPublicEntity: false,
      },
      commonForm: {
        country: EL_SALVADOR,
        department: "",
        municipality: "",
        prefijo: "",
        codactividad: "",
        descactividad: "",
        businesssector: "",
        CountryMH: "",
        isGlobalBranch: 0,
        limitcredit: 0,
        creditperiod: "",
        creditstatus: "",
        legalisnontaxable: 0,
        legalisexempt: 0,
        zoneclient: "",
        tipoingresos: "",
        SectorCSV: "",
        typeinvoice: "",
        statusinvoice: "",
        paymenttype: "",
        idseller: "",
        class: null,
        category: null,
        subcategory: null,
        noPropinas: 0,
        MostrarVentaAtercero: 0,
      },
      personForm: {
        firstname: "",
        lastname: "",
        legalname: "",
        gender: "",
        dateofbirth: "",
        age: "",
        phonenumber: "",
        mobilenumber: "",
        email: "",
        address: "",
        legaladdress: "",
        documenttype: 0,
        dui: "",
        legalnit: "",
        oldid: "",
        BccEmailsCustomer: "",
        status: 1,
      },
      businessForm: {
        businessname: "",
        businessemail: "",
        businessphone: "",
        businessmobile: "",
        legaladdress: "",
        businesswebsite: "",
        oldid: "",
        businesscontactname: "",
        businesscontactemail: "",
        businesscontactphone: "",
        businesscontactmobile: "",
        documenttype: 0,
        dui: "",
        legalname: "",
        legalnrc: "",
        legalnit: "",
        legalentity: "",
        legaltaxpayersize: "",
        typedDescActividad: "",
        legalagentretain: false,
        removerestrictionpublicentity: false,
        BccEmailsCustomer: "",
        status: 1,
      },
      dateOfBirth: "",
      personLegalNameTouched: false,
    }
  },
  computed: {
    ...mapGetters(["getCatalogMH"]),
    modeEnterprise() {
      return this.entitySelection.isBusiness || this.entitySelection.isOng || this.entitySelection.isPublicEntity
    },
    isElSalvador() {
      return this.commonForm.country === EL_SALVADOR
    },
    countryList() {
      return this.$store.getters.getCountries || []
    },
    departments() {
      return this.getCatalogMH("Departamento")
    },
    municipalities() {
      const municipalities = this.getCatalogMH("Municipio")
      if (!this.commonForm.department) return []

      return municipalities.filter((mun) => mun.Departamento == this.commonForm.department)
    },
    activities() {
      return this.getCatalogMH("ActividadEconomica").map((element) => {
        const value = String(element.Valores || "")
        return value.startsWith(element.Codigo)
          ? element
          : { ...element, Valores: `${element.Codigo} - ${value}` }
      })
    },
    tipoIngresoOptions() {
      return this.getCatalogMH("TipoIngreso")
    },
    businessEntityOptions() {
      return filterEntityOptionsByCountry(this.businessEntity, this.commonForm.country)
    },
    personDocumentType() {
      return this.documentTypes.find((doc) => doc.ID_DocumentType === this.personForm.documenttype) || null
    },
    personDocumentLabel() {
      const name = this.personDocumentType?.DocumentType || "Documento"
      return name === "NIT" ? "Número de NIT" : name
    },
    personDocumentValue: {
      get() {
        return this.personDocumentType?.DocumentType === "NIT" ? this.personForm.legalnit : this.personForm.dui
      },
      set(value) {
        if (this.personDocumentType?.DocumentType === "NIT") {
          this.personForm.legalnit = value
        } else {
          this.personForm.dui = value
        }
      },
    },
    businessDocumentType() {
      return this.documentTypes.find((doc) => doc.ID_DocumentType === this.businessForm.documenttype) || null
    },
    businessContactDocumentLabel() {
      const name = this.businessDocumentType?.DocumentType || "Documento"
      return name === "NIT" ? "Número de NIT" : name
    },
    businessContactDocumentValue: {
      get() {
        return this.businessForm.dui
      },
      set(value) {
        this.businessForm.dui = value
      },
    },
  },
  async mounted() {
    await Promise.all([this.loadPrefixes(), this.loadDocumentTypes()])
  },
  methods: {
    toggleEntity(activeKey) {
      const nextValue = !this.entitySelection[activeKey]
      Object.keys(this.entitySelection).forEach((key) => {
        this.entitySelection[key] = false
      })
      this.entitySelection[activeKey] = nextValue
    },
    syncPersonLegalName() {
      if (this.personLegalNameTouched) return

      this.personForm.legalname = `${this.personForm.firstname} ${this.personForm.lastname}`.trim()
    },
    markPersonLegalNameAsManual() {
      this.personLegalNameTouched = true
    },
    handleAddressInput(target) {
      if (target === this.personForm) {
        this.personForm.legaladdress = this.personForm.address
      }
    },
    async loadPrefixes() {
      this.prefixOptions = await this.$API.general.getParameterPool("Prefix")
    },
    async loadDocumentTypes() {
      this.documentTypes = [
        {
          DocumentType: "Sin Asignar",
          ID_DocumentType: 0,
          ID_DocumentTypeMh: null,
        },
        ...(await this.$API.documentTypes.getDocumentTypes()),
      ]
    },
    async handleCountryChange() {
      this.commonForm.department = ""
      this.commonForm.municipality = ""
      this.stateList = []
      this.cityList = []
      await this.getStates()
    },
    async getStates() {
      if (this.isElSalvador || !this.commonForm.country) return

      this.noDataLabelStates = "Cargando..."
      this.stateList = await this.$API.general.getStates(this.commonForm.country)
      this.noDataLabelStates = "No hay estados disponibles"
    },
    async getCities() {
      if (this.isElSalvador || !this.commonForm.department) return

      this.noDataLabelCities = "Cargando..."
      this.cityList = await this.$API.general.getCities(this.commonForm.department)
      this.noDataLabelCities = "No hay ciudades disponibles"
    },
    async maskNumbers() {
      if (this.personForm.mobilenumber) {
        this.personForm.mobilenumber = await numberSV(this, this.personForm.mobilenumber)
      }
      if (this.personForm.phonenumber && this.isElSalvador) {
        this.personForm.phonenumber = await numberSV(this, this.personForm.phonenumber)
      }
      if (this.businessForm.businessmobile) {
        this.businessForm.businessmobile = await numberSV(this, this.businessForm.businessmobile)
      }
      if (this.businessForm.businessphone && this.isElSalvador) {
        this.businessForm.businessphone = await numberSV(this, this.businessForm.businessphone)
      }
      if (this.businessForm.businesscontactmobile) {
        this.businessForm.businesscontactmobile = await numberSV(this, this.businessForm.businesscontactmobile)
      }
      if (this.businessForm.businesscontactphone && this.isElSalvador) {
        this.businessForm.businesscontactphone = await numberSV(this, this.businessForm.businesscontactphone)
      }
    },
    async maskNit(e) {
      if (e?.which === 8) return
      if (this.businessForm.legalnit) {
        this.businessForm.legalnit = await nitMaskHandlingHomologation(this, this.businessForm.legalnit)
      }
    },
    async maskNrc() {
      if (this.businessForm.legalnrc) {
        this.businessForm.legalnrc = await nrcMask(this, this.businessForm.legalnrc)
      }
    },
    async maskDocumentValue(target) {
      if (target === "person") {
        if (this.personDocumentType?.DocumentType === "NIT") {
          this.personForm.legalnit = await nitMaskHandlingHomologation(this, this.personForm.legalnit)
          return
        }
        if (this.personForm.documenttype == 1) {
          this.personForm.dui = await duiMask(this, this.personForm.dui)
        }
        return
      }

      if (this.businessDocumentType?.DocumentType === "NIT") {
        this.businessForm.dui = await nitMaskHandlingHomologation(this, this.businessForm.dui)
        return
      }
      if (this.businessForm.documenttype == 1) {
        this.businessForm.dui = await duiMask(this, this.businessForm.dui)
      }
    },
    calculateAgeWithDOB() {
      this.personForm.dateofbirth = this.dateOfBirth
      if (!this.dateOfBirth) {
        this.personForm.age = ""
        return
      }

      const parsed = this.parseDisplayDate(this.dateOfBirth)
      if (!parsed) {
        this.personForm.age = ""
        return
      }
      const birthDate = parsed
      const today = new Date()
      let age = today.getFullYear() - birthDate.getFullYear()
      const monthDiff = today.getMonth() - birthDate.getMonth()
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age -= 1
      }
      this.personForm.age = age >= 0 ? age : ""
    },
    calculateDOBwithAge() {
      if (!this.personForm.age) return
      const today = new Date()
      const year = today.getFullYear() - Number(this.personForm.age)
      const month = String(today.getMonth() + 1).padStart(2, "0")
      const day = String(today.getDate()).padStart(2, "0")
      this.dateOfBirth = `${day}/${month}/${year}`
      this.personForm.dateofbirth = this.dateOfBirth
    },
    parseDisplayDate(value) {
      if (!value) return null
      const [day, month, year] = String(value).split("/")
      if (!day || !month || !year) return null
      const parsed = new Date(`${year}-${month}-${day}T00:00:00`)
      if (Number.isNaN(parsed.getTime())) return null
      return parsed
    },
    changeActivity() {
      const activity = this.activities.find((act) => act.Codigo == this.commonForm.codactividad)
      this.commonForm.descactividad = activity ? activity.Valores : ""
    },
    validateBusinessTaxInfo() {
      if (!this.modeEnterprise) return true

      if (!this.businessForm.legalname) {
        this.$emit("error", "El nombre legal es obligatorio para clientes jurídicos")
        return false
      }

      if (this.isElSalvador && !this.commonForm.codactividad) {
        this.$emit("error", "La actividad económica es obligatoria")
        return false
      }

      if (!this.isElSalvador && !this.businessForm.typedDescActividad) {
        this.$emit("error", "La actividad económica es obligatoria")
        return false
      }

      if (!this.businessForm.legalentity) {
        this.$emit("error", "La entidad legal es obligatoria")
        return false
      }

      if (this.isElSalvador && !this.businessForm.legaltaxpayersize) {
        this.$emit("error", "El tamaño legal es obligatorio")
        return false
      }

      if (!this.commonForm.businesssector) {
        this.$emit("error", "El tipo de ingreso es obligatorio")
        return false
      }

      if (this.entitySelection.isBusiness && this.isElSalvador && !this.businessForm.legalnit) {
        this.$emit("error", "El NIT legal es obligatorio")
        return false
      }

      return true
    },
    buildPayload() {
      const user = JSON.parse(localStorage.getItem("user")) || {}
      if (!this.modeEnterprise) {
        const legalName = this.personForm.legalname || `${this.personForm.firstname} ${this.personForm.lastname}`.trim()
        const payload = {
          ...this.personForm,
          legalname: legalName,
          legaladdress: this.personForm.legaladdress || this.personForm.address,
          country: this.commonForm.country,
          department: this.commonForm.department,
          municipality: this.commonForm.municipality,
          prefijo: this.commonForm.prefijo,
          idbusiness: user.businessid || "",
          idbranch: user.branch || "",
          status: 1,
          isBusiness: false,
          isOng: false,
          isPublicEntity: false,
          isGlobalBranch: this.commonForm.isGlobalBranch,
          CountryMH: this.commonForm.CountryMH,
          limitcredit: this.commonForm.limitcredit,
          creditperiod: this.commonForm.creditperiod,
          creditstatus: this.commonForm.creditstatus,
          legalisnontaxable: this.commonForm.legalisnontaxable,
          legalisexempt: this.commonForm.legalisexempt,
          zoneclient: this.commonForm.zoneclient,
          tipoingresos: this.commonForm.tipoingresos,
          SectorCSV: this.commonForm.SectorCSV,
          businesssector: this.commonForm.businesssector,
          typeinvoice: this.commonForm.typeinvoice,
          statusinvoice: this.commonForm.statusinvoice,
          paymenttype: this.commonForm.paymenttype,
          idseller: this.commonForm.idseller,
          class: this.commonForm.class,
          category: this.commonForm.category,
          subcategory: this.commonForm.subcategory,
          noPropinas: this.commonForm.noPropinas ? 1 : 0,
          MostrarVentaAtercero: this.commonForm.MostrarVentaAtercero ? 1 : 0,
        }
        if (this.commonForm.country !== EL_SALVADOR) {
          payload.city = this.commonForm.municipality
          payload.state = this.commonForm.department
        }
        return payload
      }

      const payload = {
        ...this.businessForm,
        country: this.commonForm.country,
        department: this.commonForm.department,
        municipality: this.commonForm.municipality,
        codactividad: this.commonForm.codactividad,
        descactividad: this.isElSalvador ? this.commonForm.descactividad : this.businessForm.typedDescActividad,
        isGlobalBranch: this.commonForm.isGlobalBranch,
        prefijo: this.commonForm.prefijo,
        limitcredit: this.commonForm.limitcredit,
        creditperiod: this.commonForm.creditperiod,
        creditstatus: this.commonForm.creditstatus,
        businesssector: this.commonForm.businesssector,
        CountryMH: this.commonForm.CountryMH,
        legalisnontaxable: this.commonForm.legalisnontaxable,
        legalisexempt: this.businessForm.removerestrictionpublicentity ? 1 : this.commonForm.legalisexempt,
        zoneclient: this.commonForm.zoneclient,
        tipoingresos: this.commonForm.tipoingresos,
        SectorCSV: this.commonForm.SectorCSV,
        typeinvoice: this.commonForm.typeinvoice,
        statusinvoice: this.commonForm.statusinvoice,
        paymenttype: this.commonForm.paymenttype,
        idseller: this.commonForm.idseller,
        class: this.commonForm.class,
        category: this.commonForm.category,
        subcategory: this.commonForm.subcategory,
        isBusiness: this.entitySelection.isBusiness,
        isOng: this.entitySelection.isOng,
        isPublicEntity: this.entitySelection.isPublicEntity,
        idbusiness: user.businessid || "",
        idbranch: user.branch || "",
        status: 1,
      }
      if (this.commonForm.country !== EL_SALVADOR) {
        payload.city = this.commonForm.municipality
        payload.state = this.commonForm.department
      }
      payload.noPropinas = this.commonForm.noPropinas ? 1 : 0
      payload.MostrarVentaAtercero = this.commonForm.MostrarVentaAtercero ? 1 : 0
      return payload
    },
    normalizePayload(payload) {
      const normalized = { ...payload }
      normalized.dui && (normalized.dui = normalized.dui.replaceAll("-", ""))
      normalized.legalnit && (normalized.legalnit = normalized.legalnit.replaceAll("-", ""))
      normalized.legalnrc && (normalized.legalnrc = normalized.legalnrc.replaceAll("-", ""))
      return normalized
    },
    submit() {
      const valid = this.$refs.customerForm.validate()
      if (!valid) {
        this.$emit("error", "Debe completar todos los campos obligatorios")
        return
      }

      if (!this.validateBusinessTaxInfo()) {
        return
      }

      const payload = this.buildPayload()
      if (payload.legalnit) {
        const targetName = this.modeEnterprise ? "businessForm" : "personForm"
        if (!validateNITHomologation(targetName, this, "legalnit", "Número de NIT")) {
          this.$emit("error", "El NIT ingresado no es válido")
          return
        }
      }

      this.$emit("submit", {
        customerData: this.normalizePayload(payload),
      })
    },
  },
}
</script>

<style scoped>
.new-customer-screen {
  padding-bottom: 4px;
}

.entity-panel {
  padding: 12px 14px;
  margin-bottom: 12px;
  border: 1px solid #e3e6eb;
  border-radius: 10px;
  background: #fafbfc;
}

.section-block {
  margin-bottom: 14px;
  padding: 14px 16px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.entity-options {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px 28px;
}

.entity-option {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  cursor: pointer;
  font-size: 1rem;
  color: #1f2937;
  user-select: none;
}

.entity-option input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin: 0;
  accent-color: #1e88e5;
}

.segment-title {
  margin-bottom: 10px;
  color: #1f2937;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.field-row {
  margin-top: 0;
  margin-bottom: 0;
  margin-left: -6px;
  margin-right: -6px;
}

::v-deep .field-row > .col,
::v-deep .field-row > [class*="col-"] {
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 6px;
  padding-right: 6px;
  margin-bottom: 8px;
}

::v-deep .field-row .v-input {
  margin-top: 0;
}

::v-deep .field-row .v-input__slot {
  min-height: 42px !important;
}

@media (max-width: 960px) {
  .entity-options {
    gap: 12px 18px;
  }
}
</style>
